import classNames from "classnames";
import {PropsWithChildren, ReactNode} from "react";

import {Divider} from "@/components/divider/Divider.tsx";

import styles from "./TableCrown.module.scss";

export interface TableCrownProps extends PropsWithChildren {
  selectedItemsCount: number;
  selectionSummary?: ReactNode;
}

export const TableCrown = ({selectedItemsCount, selectionSummary, children}: TableCrownProps) => {
  const isDisabled = selectedItemsCount === 0;

  return (
    <div className={classNames("d-flex py-2 border-bottom text-nowrap justify-content-between", styles.crown)}>
      <div className={classNames("d-flex py-2", styles.actionBarWrapper)}>
        <div
          className={classNames("align-self-center text-end pulseTextLinkBold", {"pulse-color-gray-600": isDisabled})}
        >
          {selectionSummary ?? <>{selectedItemsCount} Selected</>}
        </div>
        {children && (
          <>
            <Divider orientation="vertical" className="ms-3" />
            <div className={classNames("d-flex align-items-center", {[styles.crownDisabled]: isDisabled})}>
              {children}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
